export default [
  'make real change',
  'brighten futures',
  'ask hard questions',
  'usher solutions',
  'hone our skills',
  'provide clarity',
];
